import { computed } from 'vue'
import { useNamespace } from '@vuesax-plus/hooks'
import type { BaseProps } from '@vuesax-plus/constants'

export const useBaseClasses = <T>(_props: T) => {
  const ns = useNamespace('component')

  const props = _props as BaseProps

  const isPrimary = computed(
    () =>
      !!props?.primary ||
      (!props?.color &&
        !props?.danger &&
        !props?.warn &&
        !props?.danger &&
        !props?.success)
  )

  return computed(
    () =>
      [
        isPrimary.value && `${ns.m('primary')}`,
        props?.danger && `${ns.m('danger')}`,
        props?.warn && `${ns.m('warn')}`,
        props?.dark && `${ns.m('dark')}`,
        props?.success && `${ns.m('success')}`,
      ] as any
  )
}
